module.exports = __webpack_public_path__ + "img/72_25.0ef4f4bd.png";